module.exports = __webpack_public_path__ + "img/Eye_Icon_Splash.11a0fe65.svg";